import { apiClient } from "./apiClient";

export type TeamRole = "admin" | "editor" | "viewer";

export interface TeamMember {
  id: string;
  email: string;
  name: string | null;
  role: TeamRole;
  status: string;
  email_verified: boolean;
  last_login_at: string | null;
  created_at: string | null;
}

export interface PendingInvitation {
  id: string;
  email: string;
  role: TeamRole;
  invited_by_user_id: string;
  expires_at: string | null;
  created_at: string | null;
}

interface Wrapped<T> {
  data: T;
}

interface TeamResponse {
  members: TeamMember[];
  pending_invitations: PendingInvitation[];
}

export async function listTeam(): Promise<TeamResponse> {
  const res = await apiClient.get<Wrapped<TeamResponse>>("/v1/team");
  return res.data;
}

export interface InviteInput {
  email: string;
  role: TeamRole;
}

export interface InviteResult extends PendingInvitation {
  /** Returned only in dev/test until mailer is wired. */
  invitation_token?: string | null;
}

export async function inviteMember(input: InviteInput): Promise<InviteResult> {
  const res = await apiClient.post<Wrapped<InviteResult>>(
    "/v1/team/invitations",
    input,
  );
  return res.data;
}

export async function revokeInvitation(id: string): Promise<void> {
  await apiClient.delete(`/v1/team/invitations/${id}`);
}

export interface AcceptInvitationInput {
  token: string;
  password: string;
  name?: string;
}

export async function acceptInvitation(input: AcceptInvitationInput): Promise<void> {
  await apiClient.post("/v1/auth/accept-invitation", input);
}

export const TEAM_ROLES: TeamRole[] = ["admin", "editor", "viewer"];
